import React from 'react';
import { useSelector } from 'react-redux';
import { getUserName } from '@redux/selectors/UserSelector';

import Button from 'react-bootstrap/Button';
import spacelistIcon from '@images/logos/vendor/spacelist_logo.svg';
import GAEventTracking from '@components/tracking/GAEventTracking';

const SpacelistWidget = () => {
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  return (
    <div className="panel-content text-center rounded" style={{ backgroundColor: 'rgb(228 227 206)', minHeight: '231px' }}>
      <img alt="spacelist-icon" src={spacelistIcon} className="img-fluid mb-4" style={{ height: '55px' }} />
      <p className="mb-4" style={{ color: 'var(--darkBackground-4)' }}>
        <strong>Spacelist™ </strong>
        is an interactive mapping tool to search billions of square feet of commercial real estate listings for free.
      </p>
      <Button
        onClick={() => {
          window.open('https://www.spacelist.ca', '_blank');
          gaEventTracker('Opened Spacelist', `${username}`);
        }}
        variant="primary"
      >
        <i className="far fa-external-link mr-2" />
        Spacelist™
      </Button>
    </div>
  );
};

export default SpacelistWidget;
